export default {
  webapi: {
    dismissTransitionMessage: '/dismiss-transition-message',
    topEmployers: {
      100: '/webapi/top-employers',
      // 50: '/webapi/top-medium-employers',
      // 10: '/webapi/top-small-employers',
    },
    topTrainingProviders: {
      50: '/webapi/top-training-providers',
    },

    cmsable: {
      industries: {
        hotJobs: (industries) => `/webapi/cmsable/hot-jobs/industry?slugs=${industries}`,
        reviews: (industries) => `/webapi/cmsable/reviews/industry?slugs=${industries}`,
        caseStudies: (industries) => `/webapi/cmsable/case-studies/industry?slugs=${industries}`,
      },
      schemes: {
        hotJobs: (schemes) => `/webapi/cmsable/hot-jobs/scheme?slugs=${schemes}`,
        reviews: (schemes) => `/webapi/cmsable/reviews/scheme?slugs=${schemes}`,
        caseStudies: (schemes) => `/webapi/cmsable/case-studies/scheme?slugs=${schemes}`,
      },
    },

    // emailTemplates: '/webapi/mailable-template/',

    // personalisation: {
    //   personalisedJobs: '/webapi/personalise/jobs/',
    //   personalisedReviews: '/webapi/personalise/reviews/',
    //   personalisedCompanies: '/webapi/personalise/companies/',
    //   relatedJobs: '/webapi/personalise/related/jobs/',
    //   relatedReviews: '/webapi/personalise/related/reviews/',
    //   relatedCompanies: '/webapi/personalise/related/companies/',
    //   topTrendingJobs: '/webapi/personalise/top-trending/jobs/',
    //   topTrendingCompanies: '/webapi/personalise/top-trending/companies/',
    // },

    entities: {
      genders: '/webapi/entities/genders',
      jobTypes: '/webapi/entities/job-types',
      jobRoles: '/webapi/entities/job-roles',
      emailFrequencies: '/webapi/entities/email-frequencies',
      institutionStartYears: '/webapi/entities/institution-start-years',
      companies: '/webapi/companies', // Note this url is intentionally different than other entities endpoints
      ethnicities: '/webapi/entities/ethnicities',
      parentProfessions: '/webapi/entities/parent-professions',
      freeSchoolMeals: '/webapi/entities/free-school-meals',
    },

    // savedSearches: {
    //   all: '/webapi/user/saved-search',
    //   individual: '/webapi/user/saved-search',
    //   create: '/webapi/user/saved-search',
    //   update: '/webapi/user/saved-search',
    //   delete: '/webapi/user/saved-search',
    //   unsubscribeAll: '/webapi/user/saved-search/unsubscribe-all',
    // },

    user: {
      activate: '/webapi/user/resend-activation/',
      registerWithPassword: '/webapi/user/register-with-password',
      registerWithoutPassword: '/webapi/user/register-without-password',
      login: '/webapi/user/login',
      update: '/webapi/user/',
      // reAuthenticate: '/webapi/user/re-authenticate',
      changePassword: '/webapi/user/password',
      savedItems: {
        get: '/webapi/saved-items',
        update: '/webapi/saved-items/',
        connect: '/webapi/saved-items/connect/',
        connectAll: '/webapi/saved-items/connect/all',
      },
      notification: {
        update: '/webapi/saved-items/notifications',
      },
      // setJobStatus: '/webapi/user/job-status',
      // jobTodoList: '/webapi/user/job-todo/by-job',
      // jobStatus: '/webapi/user/job-status',
      // saveJobTodo: '/webapi/user/job-todo',
      // jobNotesList: '/webapi/user/job-note/by-job',
      // getJobAddToCalendarLinks: '/webapi/user/job-calendar-link',
      // sendJobCalendarLink: '/webapi/user/send-job-calendar-link',
      // saveJobNote: '/webapi/user/job-note',
      changeEmail: '/webapi/user/email',
      review: '/webapi/user/reviews',
      deleteReview: '/webapi/user/review',
      dashboardItems: '/webapi/user/hub',
      // dashboardBanner: '/webapi/dashboard/banner',
      // recommendedJobs: '/webapi/user/recommended-jobs',
      // recommendedCompanies: '/webapi/user/recommended-companies',
      unsubscribeAll: '/webapi/user/unsubscribe-all',
    },
  },

  ajax: {
    reviews: {
      get: (id) => `/ajax/reviews/${id}`,
      delete: (id) => `/ajax/reviews/${id}`,
      create: '/ajax/reviews',
      updateDetails: (id) => `/ajax/reviews/${id}/job-details`,
      updateAnswers: (id) => `/ajax/reviews/${id}/answers`,
      submit: (id) => `/ajax/reviews/${id}/submit`,
    },
  },

  web: {
    navigation: {
      login: '/login',
      logout: '/logout',
      dashboard: '/dashboard',
    },

    company: {
      profile: '/company-profile',
    },

    review: {
      view: (id) => `/apprenticeship-review/${id}`,
    },
  },

  social: {
    socialShares: '/ajax/social/social-shares',
  },
};
